import { ReactNode } from 'react';

import { AuditEntityTypeName } from '@/features/audit/types';
import Pages from '@/pages';

import { UserPermissionType } from '@components/Permissions/types';

import { AuditProvider } from './providers/AuditProvider';

export const makeAuditRoute = (
  path: string | (() => string),
  element: ReactNode,
  permissions: UserPermissionType | UserPermissionType[] = [],
) => ({
  path: typeof path === 'function' ? path() : `${path}/${Pages.AUDIT}`,
  element: <AuditProvider>{element}</AuditProvider>,
  handle: {
    permissions,
  },
});

export const auditLinkTemplates = {
  [AuditEntityTypeName.CommercialMeteringPointEntity]: '..', // same as '../../ID'
  [AuditEntityTypeName.CommercialMeteringPointOwnershipEntity]:
    '../ownership-history/ID',
  [AuditEntityTypeName.GasPipelineSectionEntity]: '../gas-pipelines',
  [AuditEntityTypeName.ActBalanceOwnershipEntity]:
    '../documents/act-balance-ownership/ID',
  [AuditEntityTypeName.ViolationActEntity]: '../violation-acts/ID',
  [AuditEntityTypeName.MeteringPointActEntity]: '../metering-point-acts/ID',
  [AuditEntityTypeName.GasConsumingEquipmentEntity]: '../equipment/ID',
  [AuditEntityTypeName.MeteringDeviceEntity]: '../devices/ID',
  [AuditEntityTypeName.ModemEntity]: '../devices/modems/ID',
  [AuditEntityTypeName.SealEntity]: '../seals/ID',
  [AuditEntityTypeName.SectorBridgeActEntity]: '../bridge-acts/ID',
};
